<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderNo" placeholder="请输入单号">
						</el-input>
					</el-form-item>
					<el-form-item label="商户名称" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入商户名称">
						</el-input>
					</el-form-item>
					<!-- <el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号">
						</el-input>
					</el-form-item> -->
					
					<el-form-item label="状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="0" label="待审核" value="0">待审核</el-option>
							<el-option key="1" label="转帐中" value="1">转帐中</el-option>
							<el-option key="2" label="提现成功" value="2">提现成功</el-option>
							<!-- <el-option key="3" label="用户撤销" value="3">用户撤销</el-option> -->
							<el-option key="4" label="驳回" value="3">驳回</el-option>
						</el-select>
					</el-form-item>
		
					<el-form-item label="更新时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
		
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">导出</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="withdrawal.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="orderNo" label="单号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="storeName" label="商户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="withdrawalNum" label="提现次数" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="amount" label="提现金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fees" label="提现手续费" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="status" label="提现状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">待审核</div>
					<div v-if="scope.row.status == 1">转帐中</div>
					<div v-if="scope.row.status == 2">提现成功</div>
					<div v-if="scope.row.status == 3">驳回</div>
					
				</template>
			</el-table-column>
			<!-- <el-table-column prop="cardType" label="收款类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.cardType == 1">银行卡</div>
					<div v-if="scope.row.cardType == 2">支付宝</div>
					<div v-if="scope.row.cardType == 3">微信</div>
				</template>
			</el-table-column> -->
			<el-table-column label="收款信息" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="queryIntegralWithdrawal(scope.row.storeId)">查看
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="hjFee" label="通道手续费" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="platformSerialNo" label="流水号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="checkDatetime" label="审核时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.checkDatetime">{{scope.row.checkDatetime}}</div>
					<div v-else>未审核</div>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="驳回原因" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<!-- <div v-if="scope.row.reason">{{scope.row.reason}}</div> -->
					<div v-if="scope.row.reason">{{scope.row.reason}}</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center" width="140">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="lookyue(scope.row.storeId)"
						>余额变动记录</el-button>
					<el-button v-if="scope.row.status == 0" size="small" type="text"
						@click="shenhe(scope.row.id)">审 核</el-button>
					<div v-if="scope.row.status == 1 ">转账中</div>
					<div v-if="scope.row.status == 2 ">提现成功</div>
					<div v-if="scope.row.status == 3 ">已驳回</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="withdrawal.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="withdrawal.total" @size-change="handleSizeChange">
		</el-pagination>
		
		<!-- 查看收款信息 -->
		<el-dialog style="float:rigin" title="查看收款信息" :closeOnClickModal="false" :visible.sync="dialogDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号" class="redItem" style="width: 50%;">
							{{payment.storeCardBankNo}}
						</el-form-item>
						
						<el-form-item  label="收款人姓名:" class="redItem" style="width: 50%;">
							{{payment.storeCardName}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号类型:" class="redItem" style="width: 50%;">
							<div v-if="payment.storeCardType == 1">对公</div>
							<div v-if="payment.storeCardType == 2">对私</div>
						</el-form-item>
						
						<el-form-item v-if="payment.storeCardType == 1" label="对公收款账号:" class="redItem" style="width: 50%;">
							{{payment.storeCardChannelNo}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开户行:" class="redItem" style="width: 50%;">
							{{payment.storeCardBank}}
						</el-form-item>
						
						<el-form-item  label="开户支行:" class="redItem" style="width: 50%;">
							{{payment.storeCardSubbranch}}
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogDatil = false">取 消</el-button>
				<!-- <el-button  type="primary" @click="bohui">驳 回</el-button>
				<el-button type="primary" @click="confirm">通 过</el-button> -->
			</div>
		</el-dialog>
		
		<!-- 审核 -->
		<el-dialog style="float:rigin" title="审核" :closeOnClickModal="false" :visible.sync="shenheDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="订单号" class="redItem" style="width: 50%;">
							{{exmailDatil.orderNo}}
						</el-form-item>
						
						<el-form-item  label="收款人姓名:" class="redItem" style="width: 50%;">
							{{exmailDatil.cardUserName}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收款账号" class="redItem" style="width: 50%;">
							{{exmailDatil.cardOn}}
						</el-form-item>
						
						<el-form-item label="收款账号类型:" class="redItem" style="width: 50%;">
							<div v-if="exmailDatil.cardType == 1">对公</div>
							<div v-if="exmailDatil.cardType == 2">对私</div>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="提现数额" class="redItem" style="width: 50%;">
							￥{{exmailDatil.amount}}
						</el-form-item>
						
						<el-form-item  label="提现手续费:" class="redItem" style="width: 50%;">
							{{exmailDatil.fees}}
						</el-form-item>
					</div>
					
					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="汇聚流水号:" class="redItem" style="width: 50%;">
							{{exmailDatil.platformSerialNo}}
						</el-form-item>
						<el-form-item  label="汇聚手续费:" class="redItem" style="width: 50%;">
							{{exmailDatil.hjFee}}
						</el-form-item>
					</div> -->
				</el-form>
			</div>
			<el-dialog style="float:rigin" title="审核驳回" :visible.sync="dialogRejection" width="35%"
				:closeOnClickModal="false"  append-to-body>
				<div class="app-container">
					<el-form ref="form" :model="form2" :rules="mainFormRules" size="medium">
						<el-form-item label="驳回原因:">
							<el-col :span="18">
								<el-input v-model="form2.refuseReason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入驳回原因" />
							</el-col>
						</el-form-item>
						<el-form-item style="text-align: center;">
							<el-button :loading="loading" type="primary" @click="editCloudCheck()">提交
							</el-button>
							<el-button @click="dialogRejection=false">取 消</el-button>
							<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
			<div style="text-align: center;">
				<el-button @click="shenheDatil = false">取 消</el-button>
				<el-button  type="primary" @click="bohui">驳 回</el-button>
				<el-button type="primary" @click="confirm">通 过</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialoguser" title="余额变动记录" @close="addDialogClose" :close-on-click-modal="false"  width='1000px'>
			<div>
				<el-table :data="yuelist">
					<el-table-column property="changeType" label="变动类型">
						<template slot-scope="scope">
							<el-span v-if="scope.row.changeType==1">收入</el-span>
							<el-span v-if="scope.row.changeType=='-1'">支出</el-span>
							</template>
					</el-table-column>
					<el-table-column property="amount" label="变动金额"></el-table-column>
					<el-table-column property="operBy" label="操作人"></el-table-column>
					<el-table-column property="memo" label="备注"></el-table-column>
					<el-table-column property="createTime" label="创建时间"></el-table-column>
					
					
				</el-table>
				<el-pagination style="margin: 20px;" background :current-page="yuelist.pageNum"
					@current-change="pageChange1"
					 :current-page.sync="page1.pageNum"
					 layout="total, sizes, prev, pager, next, jumper"
					:total="allData" @size-change="handleSizeChange1">
				</el-pagination>
			</div>
			</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dialogDatil:false,
				dialoguser:false,
				allData:'',
				yuelist:[],
				shenheDatil:false, //审核弹窗
				dialogRejection:false,//驳回弹窗
				searchInfo:{},
				loading:false,
				withdrawal:{},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				page1: {
					pageNum: 1,
					pageSize: 10
				},
				payment:{},
				exmailDatil:{},
				form2:{
					refuseReason:''
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
					remak:{
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					}
				},
				payId:'',
				ids:''
			}
		},
		
		methods:{
			lookyue(id){
				this.dialoguser=true
				this.ids=id
				this.yueList()
			},
			yueList(){
				let data={
					pageNum: this.page1.pageNum,
					pageSize: this.page1.pageSize,
					storeId:this.ids
				}
				this.$api.yueList(data).then((res) => {
					console.log(res);
					if (res.state == 'success') {
						this.yuelist = res.data.list
						this.loading = false
						this.allData = res.data.total
					} else {
						this.$message.error(res.message)
					}
				})
			},
			// 查询
			search(){
				this.page.pageNum = 1;
				this.tixianList()
			},
			// 清空
			empty(){
				this.searchInfo = {}
			},
			// 导出
			downloadFile() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					cardOn:this.searchInfo.cardOn,
					orderNo:this.searchInfo.orderNo,
					status:this.searchInfo.status,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					...this.searchInfo
				}
				//   console.log(data);
				this.$api.exportExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商家提现列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			shenhe(id){
				this.payId = id
				this.shenheDatil = true
				this.$api.selectTixian(id).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.exmailDatil = res.data
					}
				})
			},
			// 通过
			confirm(){
				let data = {
					id:this.payId,
					status:1
				}
				this.$api.shenhePass(this.$encrypt(data)).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.shenheDatil = false
						this.tixianList()
					}
				})
			},
			// 驳回
			bohui(){
				this.dialogRejection = true
			},
			addDialogClose(){
				
				
				this.yuelist=[]
				this.pageChange1(1)
				console.log(this.yuelist);
			},
			editCloudCheck(){
				let data = {
					id:this.payId,
					reason:this.form2.refuseReason,
					status:3
				}
				this.$api.shenhePass(this.$encrypt(data)).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.shenheDatil = false
						this.dialogRejection = false
						this.tixianList()
					}
				})
			},
			queryIntegralWithdrawal(id){
				console.log(id);
				this.dialogDatil = true
				this.$api.getStoreId(id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
				
					if(res.state == 'success'){
						this.payment = res.data
					}
				})
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange1(data) {
				this.page1.pageNum = data
				this.yueList()
			},
			pageChange(data) {
				this.page.pageNum = data
				this.tixianList()
			},
			handleSizeChange1(val) {
				this.page1.pageSize = val
				this.yueList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.tixianList()
			},
			tixianList(){
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					cardOn:this.searchInfo.cardOn,
					orderNo:this.searchInfo.orderNo,
					status:this.searchInfo.status,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					...this.searchInfo
				}
				this.$api.storeTixian(this.$encrypt(data)).then(res=>{
				
					res=JSON.parse(this.$decrypt(res.data))
					
					if(res.state == 'success'){
						console.log(res);
						this.withdrawal = res.data
						this.loading = false
					}
				})
			}
		},
		created() {
			this.tixianList()
		}
	}
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}
	
	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}
	
	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
	
	.lpc-quill img {
		width: 100px;
		height: 120px;
	}
	
	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>